module.exports = {
      id: "bullet-arrow-usage",
      viewBox: "0 0 22 20",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#bullet-arrow",
      toString: function () {
        return this.url;
      }
    }